// extracted by mini-css-extract-plugin
export default {"title":"SettingsPage_title__Ssy8Q","buttons":"SettingsPage_buttons__RmkHO"};